export const FEU_CHILD_API_ROUTES = {
    CALCULATE_USER_VALUES: (rank) => `api/FuelEu/CalculateUserValues?rank=${rank}`,
    GET_ENERGY_MONITORING: (reportMstId, filter) => `api/FuelEu/GetEnergyMonitoring?reportMstId=${reportMstId}${filter ? `&filter=${filter}` : ""}`,
    GET_REPORT_SUMMARY: (reportMstId) => `api/FuelEu/GetFuelEuReportSummary?reportMstId=${reportMstId}`,
    GET_ENERGY_CONTRIBUTION: (reportMstId) => `api/FuelEu/GetFuelEuContribution?reportMstId=${reportMstId}`,
}